import { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const BlankPage = lazy(() => import('../../container/pages/BlankPage'));
const Placements = lazy(() => import('../../container/placement'));
const States = lazy(() => import('../../container/states'));
const Template = lazy(() => import('../../container/templates'));
const Trigger = lazy(() => import('../../container/trigger'));
const Gallery = lazy(() => import('../../container/galleryImages'));
const LandingImg = lazy(() => import('../../container/landingImage'));
const Review = lazy(() => import('../../container/review'));
const Blog = lazy(() => import('../../container/blog'));
const PlacementCompanies = lazy(() => import('../../container/placementCompanies'));
const FleetList = lazy(() => import('../../container/fleetList'));
const News = lazy(() => import('../../container/news'));
const Certificates = lazy(() => import('../../container/certificates'));
const QuizList = lazy(() => import('../../container/quiz/list'));
const QuizView = lazy(() => import('../../container/quiz/view'));
const Users = lazy(() => import('../../container/users'));
const Roles = lazy(() => import('../../container/roles'));
const RolePermissions = lazy(() => import('../../container/role-permissions'));
const PartnerMtis = lazy(() => import('../../container/partner-mtis'));
const FreshLead = lazy(() => import('../../container/students/fresh-leads'));

const ReadyForAptitudeTest = lazy(() =>
  import('../../container/students/ready-for-aptitude-test.js')
);
const AptitudeTestSubmitted = lazy(() =>
  import('../../container/students/aptitude-test-submitted')
);
const PaidFreshLeads = lazy(() => import('../../container/students/paid-fresh-leads'));
const ColdLeads = lazy(() => import('../../container/students/cold-leads'));
const ResultView = lazy(() => import('../../container/students/components/resultView'));
const ReadyForEnrollment = lazy(() => import('../../container/students/ready-for-enrollment'));
const EnrolledWithHBIMS = lazy(() => import('../../container/students/enrolled-with-hbims'));
const StudentView = lazy(() => import('../../container/students/components/enrolledStudentView'));
const SoftDeletedStudent = lazy(() => import('../../container/students/soft-deleted-students'));
const ReadyForInterview = lazy(() => import('../../container/students/ready-for-interview'));
const HrInterviewDates = lazy(() => import('../../container/hr/interview-dates.js'));

const Incentive = lazy(() => import('../../container/incentive'));
const Leave = lazy(() => import('../../container/leave'));

function PagesRoute() {
  return (
    <Routes>
      <Route index element={<BlankPage />} />
      <Route path="/placements" element={<Placements />} />
      <Route path="/state-languages" element={<States />} />
      <Route path="/templates" element={<Template />} />
      <Route path="/triggers" element={<Trigger />} />
      <Route path="/home/gallery-images" element={<Gallery />} />
      <Route path="/home/landing-images" element={<LandingImg />} />
      <Route path="/home/reviews" element={<Review />} />
      <Route path="/home/blogs" element={<Blog />} />
      <Route path="/home/placement-companies" element={<PlacementCompanies />} />
      <Route path="/home/fleet-list" element={<FleetList />} />
      <Route path="/home/news" element={<News />} />
      <Route path="/certificates" element={<Certificates />} />
      <Route path="/quiz" element={<QuizList />} />
      <Route path="/quiz/:quizId" element={<QuizView />} />
      <Route path="/users" element={<Users />} />
      <Route path="/incentive" element={<Incentive />} />
      <Route path="/leave" element={<Leave />} />
      <Route path="/roles" element={<Roles />} />
      <Route path="/role-permissions" element={<RolePermissions />} />
      <Route path="/partner-mtis" element={<PartnerMtis />} />
      <Route path="/fresh-leads" element={<FreshLead />} />
      <Route path="/paid-fresh-leads" element={<PaidFreshLeads />} />
      <Route path="/cold-leads" element={<ColdLeads />} />
      <Route path="/ready-for-aptitude-test" element={<ReadyForAptitudeTest />} />
      <Route path="/aptitude-test-submitted" element={<AptitudeTestSubmitted />} />
      <Route path="/results/:studentId" element={<ResultView />} />
      <Route path="/ready-for-enrollment" element={<ReadyForEnrollment />} />
      <Route path="/enrolled-with-hbims" element={<EnrolledWithHBIMS />} />
      <Route path="/enrolled-with-hbims/:studentId" element={<StudentView />} />
      <Route path="/soft-deleted-students" element={<SoftDeletedStudent />} />
      <Route path="/ready-for-interview" element={<ReadyForInterview />} />
      <Route path="/hr-interview-dates" element={<HrInterviewDates />} />
    </Routes>
  );
}

export default PagesRoute;
